export const SectionHeroTranslationsUk = {
  'Platform Description':
    'платформа оренди вишуканого вбрання і товарів для дітей і сімʼї ',
  rent: 'орендувати',
};
